import React from 'react';
import { motion } from 'framer-motion';
import { Users, Database, Target, ShieldCheck } from 'lucide-react';

const stats = [
  { 
    value: '3+', 
    label: 'Exclusive Pilot Partners', 
    icon: Users,
    description: 'Bespoke AI implementations'
  },
  { 
    value: '500k+', 
    label: 'High-Fidelity Records', 
    icon: Database,
    description: 'Precision labeled data points'
  },
  { 
    value: '3', 
    label: 'Industry Verticals', 
    icon: Target,
    description: 'Deep domain specialization'
  },
  { 
    value: '99.9%', 
    label: 'Extraction Precision', 
    icon: ShieldCheck,
    description: 'Enterprise-grade accuracy'
  },
];

export default function StatsBar() {
  return (
    <section className="bg-slate-900 border-y border-slate-800 relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-64 h-64 bg-blue-500/10 blur-[100px] rounded-full pointer-events-none" />
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-64 h-64 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: "easeOut" }}
              className="flex flex-col items-center text-center group"
            >
              <div className="mb-6 p-4 rounded-2xl bg-slate-800/60 border border-slate-700/50 group-hover:border-blue-500/50 transition-colors duration-500 shadow-xl shadow-black/20">
                <stat.icon className="w-7 h-7 text-blue-400 group-hover:text-blue-300 transition-colors" />
              </div>
              
              <div className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-2">
                {stat.value}
              </div>
              
              <div className="text-sm font-bold text-blue-400 uppercase tracking-widest mb-2">
                {stat.label}
              </div>
              
              <div className="text-xs text-slate-400 font-medium">
                {stat.description}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
